import React, { useContext, useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
  Container,
  Divider,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  LockReset,
  Badge,
  Receipt,
  LocalShipping,
  StarOutlineSharp
} from '@mui/icons-material';
import ChangePassword from './ChangePassword.js';
import KycDetails from './KycDetails.js';
import BillingDetails from './BillingDetails.js';
import { CommonContext, } from '../../../context';
import Courier from './courier/Courier.js';
import OrderStatus from './orderStatus/OrderStatus.js';

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index} className="tab-panel">
      {value === index && (
        <Box className="tab-panel-box">
          {children}
        </Box>
      )}
    </div>
  );
}

export default function VerticalTabs() {
  const { rowData } = useContext(CommonContext);
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="lg" className="vertical-tabs-container" disableGutters={isMobile}>
      <Paper elevation={3} className="tabs-paper">
        <Box className="tabs-wrapper">
          {/* Vertical Tabs */}
          <Tabs
            orientation={isMobile ? "horizontal" : "vertical"}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons={isMobile ? "auto" : false}
            value={value}
            onChange={handleChange}
            className="vertical-tabs"
          >
            <Tab
              icon={<LockReset className="tab-icon" />}
              label="Change Password"
              iconPosition="start"
              className="tab-item"
            />
            <Tab
              icon={<Badge className="tab-icon" />}
              label="KYC Details"
              iconPosition="start"
              className="tab-item"
            />
            <Tab
              icon={<Receipt className="tab-icon" />}
              label="Billing Details"
              iconPosition="start"
              className="tab-item"
            />
            <Tab
              icon={<LocalShipping className="tab-icon" />}
              label="Couriers"
              iconPosition="start"
              className="tab-item"
            />
            <Tab
              icon={<StarOutlineSharp className="tab-icon" />}
              label="Order Status"
              iconPosition="start"
              className="tab-item"
            />
          </Tabs>

          {/* Tab Panels */}
          <Box className="tab-content">
            {/* Change Password Panel */}
            <TabPanel value={value} index={0}>
              <Card className="content-card">
                <CardContent className="card-content">
                  <Box className="card-header">
                    <LockReset className="header-icon" />
                    <Typography variant="h5" className="header-title">
                      Change Password <small>for {rowData?.company_name}</small>
                    </Typography>
                  </Box>
                  <Divider className="header-divider" />
                  <ChangePassword />
                </CardContent>
              </Card>
            </TabPanel>

            {/* KYC Details Panel */}
            <TabPanel value={value} index={1}>
              <Card className="content-card">
                <CardContent className="card-content">
                  <Box className="card-header">
                    <Badge className="header-icon" />
                    <Typography variant="h5" className="header-title">
                      KYC Details <small>for {rowData?.company_name}</small>
                    </Typography>
                  </Box>
                  <Divider className="header-divider" />
                  <KycDetails />
                </CardContent>
              </Card>
            </TabPanel>

            {/* Billing Details Panel */}
            <TabPanel value={value} index={2}>
              <Card className="content-card">
                <CardContent className="card-content">
                  <Box className="card-header">
                    <Receipt className="header-icon" />
                    <Typography variant="h5" className="header-title">
                      Billing Details <small>for {rowData?.company_name}</small>
                    </Typography>
                  </Box>
                  <Divider className="header-divider" />
                  <BillingDetails />
                </CardContent>
              </Card>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Card className="content-card">
                <CardContent className="card-content">
                  <Box className="card-header">
                    <LocalShipping className="header-icon" />
                    <Typography variant="h5" className="header-title">
                      Courier <small>for {rowData?.company_name}</small>
                    </Typography>
                  </Box>
                  <Divider className="header-divider" />
                  <Courier />
                </CardContent>
              </Card>
            </TabPanel>
            <TabPanel value={value} index={4}>
              <Card className="content-card">
                <CardContent className="card-content">
                  <Box className="card-header">
                    <StarOutlineSharp className="header-icon" />
                    <Typography variant="h5" className="header-title">
                      Order Status <small>for {rowData?.company_name}</small>
                    </Typography>
                  </Box>
                  <Divider className="header-divider" />
                  <OrderStatus />
                </CardContent>
              </Card>
            </TabPanel>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}